import { toast } from 'react-toastify';

function handleError() {
  toast.error('Servidor indisponível');

  return;
}

export default handleError;
